import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import Loader from 'features/Loader/Loader';
import Button from 'shared/components/button/Button';
import { addClientProgressPhotos } from '../ducks/ProgressActions';
import ProgressPhotosForm from './ProgressPhotosForm';

class ProgressPhotosAdd extends React.Component {
  render() {
    const {
      setModalOpen,
      openModal,
      addClientProgressPhotos,
      clientId
    } = this.props;

    return (
      <div>
        <Modal isOpen={openModal} className="progress-photos-modal">
          <ModalHeader>
            <span>Add Photo</span>
            <span className="modal-close" onClick={() => setModalOpen(false)}>
              Close
            </span>
          </ModalHeader>
          <ModalBody>
            <Formik
              initialValues={{
                front: '',
                back: '',
                side: ''
              }}
              validate={values => {
                if (
                  values.front === '' ||
                  values.back === '' ||
                  values.side === ''
                )
                  return 'Error';
                return true;
              }}
              onSubmit={values => {
                return addClientProgressPhotos(clientId, values).then(() =>
                  setModalOpen(false)
                );
              }}
            >
              {formik => (
                <Form>
                {formik.isSubmitting ? (
                  <Loader />
                ) : (
                  <div>
                    <ProgressPhotosForm setValue={formik.setFieldValue} />
                    <div className="form-action">
                      <p>Please upload three photos then click “Submit”.</p>
                      <Button
                        id=""
                        type="submit"
                        btnBlock=""
                        btnSize=""
                        color="primary"
                        disabled={(formik.values.front === '' ||
                          formik.values.back === '' ||
                          formik.values.side === '') || formik.isSubmitting}
                        label={`Submit${formik.isSubmitting ? '...' : ''}`}
                      />
                    </div>
                  </div>
                  )}
                </Form>
              )}
            </Formik>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addClientProgressPhotos: (clientId, values) =>
      dispatch(addClientProgressPhotos(clientId, values))
  };
}

export default connect(null, mapDispatchToProps)(ProgressPhotosAdd);
